import { render, staticRenderFns } from "./LinkmanList.vue?vue&type=template&id=3b6200e3&scoped=true&"
import script from "./LinkmanList.vue?vue&type=script&lang=js&"
export * from "./LinkmanList.vue?vue&type=script&lang=js&"
import style0 from "./LinkmanList.vue?vue&type=style&index=0&id=3b6200e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6200e3",
  null
  
)

export default component.exports